import styled from 'styled-components'
import { Link } from '@sketch/components'

export const ContentLayout = styled.div`
  font-size: ${({ theme }) => theme.fontSizes.C};
`

export const TitleWrapper = styled.div`
  display: flex;
  align-items: flex-start;
  font-weight: ${({ theme }) => theme.fontWeights.semibold};
`

export const ChildrenContainer = styled.div`
  padding: ${({ theme }) => theme.space[1]}px 0;
`

export const NoticeIcon = styled.svg`
  width: 17px;
  height: 17px;
  flex-shrink: 0;
  margin-right: 8px;
  color: var(--notice__icon);
`
export const ActionContainer = styled.div`
  margin-top: ${({ theme }) => theme.space[3]}px;
`

export const LearnMoreLink = styled(Link)`
  color: var(--notice__link-color);
  font-size: ${({ theme }) => theme.fontSizes.D};

  /* Overwrite the default margin-left for links following a button */
  &&:not(:first-child) {
    margin-left: 11px; /* stylelint-disable-line scales/space */
  }

  &:hover {
    color: var(--notice__link-color-hover);
  }
`
